import BaseApi from './base.api'
import ApiService from "@services/api.service";

export default {
    ...BaseApi,
    ...{
        resource: 'users',
    },
    isUserExists(params = null) {
            return ApiService.post(`/${this.resource}/exists`, params)
    },
    check(params){
        return ApiService.post(`/${this.resource}/data/check`, params)
    },
    changeAnnouncementStatus(id,params)
    {
        return ApiService.get(`/${this.resource}/changeAnnouncementStatus/${id}`, params)

    },
    changeWeeklyPlanStatus(id,params)
    {
        return ApiService.get(`/${this.resource}/changeWeeklyPlanStatus/${id}`, params)

    },
    storeFeeType(params)
    {
        return ApiService.post(`${this.resource}/fee-types`,params)

    },

    getAddedByUsers(params){
        return ApiService.get(`${this.resource}/added-by-users`,params);
    },
    updateProfile(params = null) {
        return ApiService.post(`/${this.resource}/profile/${params.id}`, params)
    },
}
